import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'; 
import Home from './Home';
import Loginpage from './Loginpage';
import './App.css';
import Landing from './Landing';


function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
        <Route path="/" element={<Landing />} />
          <Route path="/cookies-accept/" element={<Home />} />
          <Route path="/files-download/" element={<Loginpage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
